/**
 * Build query string for /api/admin/entity-type-attributes.
 * Prefer canonical type name over entity_type_id — per-id cache can be stale
 * (e.g. solution-component reintroduced after cache preload).
 */
export function buildEntityTypeAttributesQueryParams(
  entityTypeName,
  entityTypeId
) {
  const normalizedTypeName = String(entityTypeName || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "-");
  if (normalizedTypeName) {
    return `entity_type_name=${encodeURIComponent(normalizedTypeName)}`;
  }
  const id = String(entityTypeId || "").trim();
  if (id) {
    return `entity_type_id=${encodeURIComponent(id)}`;
  }
  return null;
}
